import React,{useEffect,useState} from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

import Accred from '../../images/bestHotel-removebg-preview.png';
import PinClip from '../../images/PinClip.png';
import bestpricelogo from '../../images/bestpricelogo.png';
import seal from '../../images/seal.jpeg';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';


import './Explore.css';
import { createPost } from '../../actions/posts';
import { FiBold } from 'react-icons/fi';



function Explore(props) {
    

    const [postData,setPostData]= useState({checkIn:'',checkOut:'',rooms:'',adults:'',children:''});

    const dispatch = useDispatch();

    const handleSubmit = (e)=>{
        e.preventDefault()

        dispatch(createPost(postData));
    }

    useEffect(() => {
        // window.scroll(0,0)
     }, [])

     

    return (
        <Container  fluid id='explore' className={'ExploreWrapper'}>
            <h2 className='about'>ABOUT US</h2>
            <Row >
                <Col lg={10} md={10} sm={12} xs={12} >
                    <div>
                        
                        
                        <p style={{textAlign:'justify'}}>
                       
                        <span className='bold' >Sai Shreyas Residency</span>  is a <b>quiet, comfortable Hotel</b> conveniently situated away from the congestion
                        and crowds close to <b>Kempegowda International Airport</b>, Bangalore. It's a perfect gateway hotel for <b>weekend
                        adventurers, romantic couples, businessmen</b>, and <b>airport transit travellers</b> ideally suited for short and long stays.<br/>
                        The hotel offers a flawless blend of:
                        <p>

                        </p>
                        <li>Exceptional services and facilities,</li>
                        <li>Premium comfort, </li>
                        <li>Utmost privacy, </li>
                        <li>Inviting décor and </li>
                        <li>Hygienic atmosphere.</li>

                        </p>
                        <p style={{textAlign:'justify'}}>
                        <span className='bold' >Sai Shreyas Residency</span> houses only 14 Rooms, making it a perfect place to enjoy the quiet as your residence. Each
                        room is carefully designed to offer a modern and cozy ambiance, with comfortable lighting, bed and a functional bathroom
                        adhering to international standards. The rooms are spacious enough to accommodate two or more guests and provide utmost comfort
                        with air-conditioned, premium linen, complimentary water bottles, security wardrobes, smart TV, high-speed internet, office table
                        and many more features. Please check the Rooms and Amenities tab for more details.<br/>
                        We offer all-inclusive premium features at the most affordable prices unpaired to any other Hotel in our locality. These features,
                        coupled with our 24-hour room service and friendly hospitality, ensure you have a relaxing stay at Sai Shreyas Residency. We at Sai Shreyas
                        Residency strongly believe in providing the best service, facilities, value for money and satisfaction for our beloved guests. 
                        The hotel was recently founded by a family of Government Employees, Doctors and Engineers on Dec 5th, 2021. The family has travelled to more than
                        30 countries and stayed in numerous hotels worldwide. With their tremendous experience and understanding as customers, the hotel was carefully planned
                        and materialized with the sole aim of customer's utmost satisfaction and hygiene. In contrast, the hotel staff has immense experience in hospitality services,
                        making the management an ideal partner for all your needs.  
                        </p>
                        <p style={{textAlign:'justify'}}>
                        <span className='bold' >Sai Shreyas Residency</span> is perfectly situated on the Bangalore-Hyderabad express highway, making it the
                         <b> most convenient hotel</b> for travellers who desire to explore the various <b>brand factory outlets</b> (Sketchers, Levi's, PUMA, Jockey, Van Heusen, Louis Phillippe, Nike,
                        Adidas and many more), <b>sports complex</b> (Decathlon Anubhava), café's (Third Wave Coffee, Cafe Noir Cargo, Haldiram's), <b>restaurants</b> (Itihaas, Mcdonalds, Burger King, A2B)
                        and <b>convention centers</b> (Moongate and KNS), which are all surprisingly close to our hotel. Consider reaching these places by just a <b>5-10 minutes’ walk</b>. Please check the Places-to-visit
                        page for details on nearby places and attractions with distance and time from our hotel.
                        </p>
                       
                        
                        
                    </div>
                    
                </Col>











                

                <Col className='Partie2'   lg={2} md={2} sm={12} xs={12} style={{paddingLeft:'0'}}>
                    {/* <div> */}
                    <div className=''>
                            <img  className='award-logo' src={PinClip} alt='tof' />
                            <p style={{color:'#d7260f',display:'flex',justifyContent:'center'}}>Just 15 mins drive to BLR Airport</p>
                        </div>
                        {/* <div className='Bwrapper'>
                            <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/vUfApfo0KOXlrlnVf110ng/#/search'>
                                <Button style={{width:'80%'}}  variant='warning'>Book Now</Button>
                            </a>
                            
                        </div> */}
                        <div className=''>
                            <img  className='award-best-hotel' src={Accred} alt='tof' />
                           
                        </div>
                    {/* </div> */}
                        
                        <div className='AwardWrapper'>
                            <img  className='award-logo' src={bestpricelogo} alt='tof' />
                           
                        </div>
                        

                    {/* <Form className='AvailabilityForm'>
                        
                        <Row>
                            <Col lg={6}>
                                <Form.Group>
                                <Form.Label>Check-In</Form.Label>
                                <Form.Control  type='date' value={postData.checkIn} name='CheckIn' onChange={(e) =>setPostData({...postData,checkIn:e.target.value})} required />
                                </Form.Group>

                            </Col>
                            <Col lg={6}>
                                <Form.Group>
                                <Form.Label>Check-Out</Form.Label>
                                <Form.Control value={postData.checkOut} name='CheckOut' type='date' onChange={(e) =>setPostData({...postData,checkOut:e.target.value})} required />
                                </Form.Group>
                            </Col>
                            
                        </Row>
                        <Row>
                            <Col lg={4}>
                                <Form.Group>
                                <Form.Label>Rooms</Form.Label>
                                    <Form.Select value={postData.rooms} name='rooms' onChange={(e) =>setPostData({...postData,rooms:e.target.value})} required>
                                        <option  defaultValue hidden>No of rooms </option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                    </Form.Select>
                                   
                                </Form.Group>
                            </Col>
                            <Col lg={4}>
                                <Form.Group>
                                <Form.Label>Adults</Form.Label>
                                    <Form.Select value={postData.adults} name='adults' onChange={(e) =>setPostData({...postData,adults:e.target.value})}  required>
                                        <option  defaultValue hidden>No of adults </option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                    </Form.Select>
                                   
                                </Form.Group>
                            </Col>
                            <Col lg={4}>
                                <Form.Group>
                                <Form.Label>Children</Form.Label>
                                    <Form.Select value={postData.children} onChange={(e) =>setPostData({...postData,children:e.target.value})} name='children'  required>
                                        <option  defaultValue hidden>No of children </option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                    </Form.Select>
                                   
                                </Form.Group>
                            </Col>
                        </Row>
                       
                        <Row className="AvailabilityRow">
                            <Button type='submit' className='AvailabilityBtn' onClick={handleSubmit}>Check Availability</Button>
                        </Row>
                        
                    </Form> */}
                </Col>
            </Row>
            <div>
                
            </div>
        </Container>
    )
}

export default Explore
